module.exports = __webpack_public_path__ + "img/cash.09c60397.png";